import React from 'react'
import { Loader } from 'semantic-ui-react'

export default function Loading(props) {
  return <Loader active inline='centered' style={props.style} />
}
